import { useCallback, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { isHomepage } from 'helpers';
import { useIsomorphicLayoutEffect } from './common';

export const useLiteMode = (ssrLiteMode: boolean, navOffsetTop = 0) => {
  const router = useRouter();
  const [isLite, setIsLite] = useState(ssrLiteMode);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const listenScrollEvent = (): void => {
    const scrollOffSetTop =
      window.pageYOffset || document.documentElement.scrollTop;
    if (isHomepage(router.asPath)) {
      if (scrollOffSetTop > navOffsetTop) {
        setIsLite(true);
      } else {
        setIsLite(false);
        setDropdownOpen(false);
      }
    } else {
      setIsLite(true);
    }
  };

  useEffect(() => {
    setDropdownOpen(false);
  }, [router.query]);

  useEffect(() => {
    window.addEventListener('scroll', listenScrollEvent);
    return (): void => {
      window.removeEventListener('scroll', listenScrollEvent);
    };
  }, [router.asPath, navOffsetTop]);

  useIsomorphicLayoutEffect(() => {
    setIsLite(!isHomepage(router.asPath));
  }, [router.asPath]);

  const toggle = useCallback(() => {
    setDropdownOpen(!dropdownOpen);
  }, [dropdownOpen]);

  return {
    isLite,
    dropdownOpen,
    toggle,
  };
};
